/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Groups_TextInputs */



/**
* | output |
* | --- |
* | "Groups control which folders and KNP lists members can see." |
*
* @param {Team_Manager_No_Groups_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_groups_text = /** @type {((inputs?: Team_Manager_No_Groups_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Groups_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les groupes déterminent les dossiers et listes KNP visibles par les membres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen legen fest, welche Ordner und KNP-Listen Mitglieder sehen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I gruppi stabiliscono quali cartelle ed elenchi KNP vedono i membri.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы определяют, какие папки и списки KNP видят участники.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los grupos controlan qué carpetas y listas KNP ven los miembros.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("群组控制成员可以查看哪些文件夹和 KNP 列表。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループでメンバーが表示できるフォルダーと KNP リストを管理します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह तय करते हैं कि सदस्य कौन-से फ़ोल्डर और KNP सूचियाँ देख सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os grupos controlam que pastas e listas KNP os membros veem.")
	return /** @type {LocalizedString} */ ("Groups control which folders and KNP lists members can see.")
});